// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/button/index.css
// module id = 1769
// module chunks = 148